import React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import SpaceCardItem from './SpaceCardItem';
import { useEffect, useRef } from 'react';
import {isMobileOnly} from 'react-device-detect';
import Slider from "react-slick";
import SlideBtn from '../../components/common/button/SlideBtn';

const SpaceEsSliderBlock = styled.div`
    //width:100%;
    max-width: ${isMobileOnly?'100vw':'1236px'};
    //overflow: hidden;
    position:relative;

    margin-left: -30px;
    margin-right: -30px;

    ${isMobileOnly&&`
        .si-list {margin-left:0; margin-right:0;} //reset left/right margin for mobile    
        // .slick-list{padding:0 20% 0 0 !important;}
    `}
    
    .slick-track {${isMobileOnly&&"display:flex"}};
    .slick-arrow.slick-next {
        ${isMobileOnly?"top:35%;right:30px":"right:-3px"};
        //background: url('/assets/images/icon/tour_next-icon.png') center center/auto no-repeat;
     }
    .slick-arrow.slick-prev {
        ${isMobileOnly?"top:35%;left:30px":"left: -2px"};
        //background: url('/assets/images/icon/tour_prev-icon.png') center center/auto no-repeat;
    }
`;

const SpaceItemSlideBlock = styled.div`
    width: 1190px;
    -webkit-transform: translateX(-10px);
    -ms-transform: translateX(-10px);
    transform: translateX(-10px);
`;

const SpaceSlickListBlock = styled.div`
    position: relative;
    display: block;
    overflow: hidden;
    margin: 0 20px;
    padding: 0;
`;

const BtnBlock = styled.button`
    //border-top-left-radius: 4px;
    //border-bottom-left-radius: 4px;
    top:50%;
    position: absolute;
    width: 50px;
    height: 50px;
    display: ${props => props.isShow};
    background-image:url(${props => props.img});
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    text-indent: -9999px;
    overflow: hidden;
    border-radius: 10px;
    -webkit-box-shadow: 0.9px 1.8px 12px 0 rgba(44, 44, 44, 0.14);
    box-shadow: 0.9px 1.8px 12px 0 rgba(44, 44, 44, 0.14);
    -webkit-transition: background 0.3s, opacity 0.3s;
    -o-transition: background 0.3s, opacity 0.3s;
    transition: background 0.3s, opacity 0.3s;
    z-index: 1;
    
    &:hover {
        transition: all 0.3s ease-in-out;
        background-image:url(${props => props.hover});
        // background-color: #00d9b8;
        color: #fff;
    }
`;
const PrevBtnBlock = styled(BtnBlock)`
left: ${isMobileOnly?"10vw":"15px"};
`;
const NextBtnBlock = styled(BtnBlock)`
//right: ${isMobileOnly?"-5px":"10px"};
${isMobileOnly?"left:85vw":"right: 10px"};
`;
/*
const PrevBtnBlock = styled.button`
    left: 15px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    position: absolute;
    top: 50%;
    width: 50px;
    height: 50px;
    display: ${props => props.isShow};
    background-image:url(${props => props.img});
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    text-indent: -9999px;
    overflow: hidden;
    border-radius: 10px;
    -webkit-box-shadow: 0.9px 1.8px 12px 0 rgba(44, 44, 44, 0.14);
    box-shadow: 0.9px 1.8px 12px 0 rgba(44, 44, 44, 0.14);
    -webkit-transition: background 0.3s, opacity 0.3s;
    -o-transition: background 0.3s, opacity 0.3s;
    transition: background 0.3s, opacity 0.3s;
    z-index: 999;


    &:hover {
        transition: all 0.3s ease-in-out;
        background-image:url(${props => props.hover});
        // background-color: #79b88a;
        color: #fff;
    }
`;

const NextBtnBlock = styled.button`
    right: 10px;
    position: absolute;
    top: 50%;
    width: 50px;
    height: 50px;
    display: ${props => props.isShow};
    background-image:url(${props => props.img});
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    text-indent: -9999px;
    overflow: hidden;
    border-radius: 10px;
    -webkit-box-shadow: 0.9px 1.8px 12px 0 rgba(44, 44, 44, 0.14);
    box-shadow: 0.9px 1.8px 12px 0 rgba(44, 44, 44, 0.14);
    -webkit-transition: background 0.3s, opacity 0.3s;
    -o-transition: background 0.3s, opacity 0.3s;
    transition: background 0.3s, opacity 0.3s;
    z-index: 1;

    &:hover {
        transition: all 0.3s ease-in-out;
        background-image:url(${props => props.hover});
        // background-color: #79b88a;
        color: #fff;
    }
`;
*/


const SpaceEsSlider = ({ items, count, useEs=false, refSlider=null, marginTop="20px" }) => {

    const [startSlide, setStartSlide] = useState(0);
    const [dispSlide, setDispSlide] = useState([]);

    /* const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        // variableWidth: true,
        slidesToShow: isMobileOnly?1.3:3,  // 1 slide if mobile
        slidesToScroll: 1,
        arrows: !(useEs || isMobileOnly),
        swipeToSlide: true
      }; */
      const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        // variableWidth: true,
        slidesToShow: isMobileOnly?1.3:3,  // 1 slide if mobile
        slidesToScroll: 1,
        arrows: !(useEs || isMobileOnly),
        nextArrow: <SlideBtn className="left" right={true} top="35%"/>,
        prevArrow: <SlideBtn className="left" top="35%"/>,
        swipeToSlide: true
      };

    useEffect(() => {

        setDispSlide(items);

        // setImgInfo(items)
        /* if (items != null && count > dispNum) {
            setDispSlide(items.slice(startSlide, startSlide + dispNum));
        } else {
            setDispSlide(items);
        } */
    }, [startSlide, items])

    const handlePrevClick = () => {
        setStartSlide(startSlide - 1)
    }

    const handleNextClick = () => {
        setStartSlide(startSlide + 1)
    }


    if (dispSlide.length === 0) {
        return <SpaceEsSliderBlock/>
    }

    return (
        <SpaceEsSliderBlock className="scroll_item-wrap2" style={{marginTop:marginTop}}>

            <div className = "si-list slick-initialized slick-slider">
                <Slider ref={refSlider} {...settings} >
                        {
                            dispSlide.map((curitem, index) => {

                                return <SpaceCardItem
                                    width={isMobileOnly?'92vw':'412px'}
                                    key={curitem.st_id}
                                    iteminfo={curitem}
                                    paddingLeft={isMobileOnly? "0px": "31px"}
                                        paddingTop={"0px"}
                                        //height={"337px"}
                                />
                            })
                        }
                </Slider>
            </div>

            {/* <SpaceItemSlideBlock>
                <SpaceSlickListBlock>
                    {
                        dispSlide.map((curitem, index) => {

                            return <SpaceCardItem
                                key={curitem.st_id}
                                iteminfo={curitem}
                                paddingLeft='20px'
                                paddingRight='15px'
                            />
                        })
                    }
                </SpaceSlickListBlock>

                <PrevBtnBlock
                    img={"/assets/images/icon/tour_prev-icon.png"}
                    hover={"/assets/images/icon/tour_prev-icon_hover.png"}
                    isShow={startSlide > 0 ? 'block' : 'none'}
                    onClick={handlePrevClick} />
                <NextBtnBlock
                    img={"/assets/images/icon/tour_next-icon.png"}
                    hover={"/assets/images/icon/tour_next-icon_hover.png"}
                    isShow={(startSlide + dispNum) < count ? 'block' : 'none'}
                    onClick={handleNextClick} />

            </SpaceItemSlideBlock> */}
        </SpaceEsSliderBlock>
    );
};

export default SpaceEsSlider;
